"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeViewQueryState = exports.encodeViewQueryState = void 0;
const lz_string_1 = require("lz-string");
const view_query_params_normalizers_1 = require("./view-query-params.normalizers");
const view_query_params_parsers_1 = require("./view-query-params.parsers");
const encodeViewQueryState = (state, defaults) => {
    const normalizedState = (0, view_query_params_normalizers_1.normalizeViewQueryState)(state, defaults);
    if (!normalizedState)
        return undefined;
    return (0, lz_string_1.compressToEncodedURIComponent)(JSON.stringify(normalizedState));
};
exports.encodeViewQueryState = encodeViewQueryState;
const decodeViewQueryState = (encodedState) => {
    if (!encodedState)
        return null;
    try {
        const decompressedState = (0, lz_string_1.decompressFromEncodedURIComponent)(encodedState);
        if (!decompressedState)
            return null;
        return (0, view_query_params_parsers_1.parseViewQueryState)(JSON.parse(decompressedState));
    }
    catch (_a) {
        return null;
    }
};
exports.decodeViewQueryState = decodeViewQueryState;
